import { LibrarySkeleton } from '@/components/Library/LibrarySkeleton';
import { VIDEO_TILE_WIDTH, VideoTile } from '@/components/VideoTile';
import { SectionTitle } from '@/pages/home/components/Common';
import { VideoBulkActionsBar } from '@/pages/video-library/components/VideoBulkActionsBar';
import { useAuth } from '@/services/auth';
import { useCurrentLibraryItems, useFilterVideos } from '@/state/video-library/videoLibrary';
import { AppRoutes } from '@/utils/types';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVideoDisplayLimit } from '../../hooks/useVideoDisplayLimit';
import {
    WorkspaceSectionContainer,
    WorkspaceSectionHeader,
    WorkspaceSectionHeaderButton,
    WorkspaceTileList,
} from '../workspaceComponents/common';

export const RecentVideos = () => {
    const { isAnonymous } = useAuth();
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement | null>(null);

    const { items: libraryItems, libraryLoaded } = useCurrentLibraryItems();
    const { getFilteredVideos } = useFilterVideos();
    const filteredLibraryItems = getFilteredVideos(libraryItems);

    const limit = useVideoDisplayLimit(ref, filteredLibraryItems.length);

    const elements = [...filteredLibraryItems].splice(0, limit);
    const showSeeAll = filteredLibraryItems.length > elements.length;

    if (!libraryLoaded && !isAnonymous) {
        return (
            <WorkspaceSectionContainer>
                <WorkspaceSectionHeader>
                    <SectionTitle id="recent-videos-section">My Videos</SectionTitle>
                </WorkspaceSectionHeader>
                <LibrarySkeleton amount={3} tileHeight="190px" tileWidth={`${VIDEO_TILE_WIDTH}px`} />
                <VideoBulkActionsBar />
            </WorkspaceSectionContainer>
        );
    }

    if (!filteredLibraryItems?.length) {
        return null;
    }

    return (
        <WorkspaceSectionContainer>
            <WorkspaceSectionHeader>
                <SectionTitle id="recent-videos-section">My Videos</SectionTitle>
                {showSeeAll && (
                    <WorkspaceSectionHeaderButton onClick={() => navigate(AppRoutes.VideoStudio)}>See all</WorkspaceSectionHeaderButton>
                )}
            </WorkspaceSectionHeader>

            <WorkspaceTileList ref={ref}>
                {elements.map(item => (
                    <VideoTile key={item.id} item={item} origin="home" />
                ))}
            </WorkspaceTileList>
            <VideoBulkActionsBar />
        </WorkspaceSectionContainer>
    );
};
